import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigation';

/**
 * Publishes the router's navigate to the OIDC callback. Renders nothing.
 *
 * Mounted as a sibling of the OIDC provider rather than a child, so it is still there
 * during the callback render, which is when it is needed.
 */
export default function RouterBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate((path) => navigate(path, { replace: true }));
    return () => setNavigate(null);
  }, [navigate]);

  return null;
}
